import React from 'react';
import { Icons } from '../../../components/atoms/SVG';
import { ButtonMinorAction } from '../../../components/molecules/Btn/ButtonWrapper';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { TooltipPlacement } from '../../../components/atoms/Tooltip';

export function AToZToNavButton({ id, hint }: { id: string; hint: string }) {
  const { t } = useSonTranslation('AToZContainer');

  return (
    <div className="a-to-z-container__character-group">
      <strong className="a-to-z-container__character-heading font-bold-16-24">
        <span className="invisible">{hint}</span>
        {id.toUpperCase()}
      </strong>
      <div className="a-to-z-container__table-jump-to-list-button">
        <ButtonMinorAction
          id={`char-${id}`}
          href={`#navigation-item-${id}`}
          icon={Icons.UP_CIRCLE_ARROW_FULL}
          text={t('charactergroup.backToTop.title')}
          tooltipPlacement={TooltipPlacement.RIGHT}
        />
      </div>
    </div>
  );
}
